export default "__VITE_ASSET__Bpjf5SUW__"